export default __webpack_public_path__ + "static/media/Bruno_Miranda-Edit-LR.fc7fd2eb.jpg";